import React from "react";
import { Table } from "antd";
import { ModalBase } from "../../../../../../Components/Modais/ModalBase/ModalBase";
import { formatDate } from "../../../../shared/utils/audbilityFormatters";
import {
  EMPTY_SCREENINGS_LABEL,
  PATIENT_CREATED_AT_PREFIX,
  getScreeningsCountText,
} from "../../../constants";
import DetailsCard from "../../DetailsCard/DetailsCard";
import { PATIENT_SCREENINGS_COLUMNS } from "./columns";
import classes from "./PatientDetailsModal.module.scss";

const PatientDetailsModal = ({ patient, onClose }) => (
  <ModalBase
    animated={false}
    open={Boolean(patient)}
    onCancel={onClose}
    title={
      <div className={classes.ModalTitle}>
        <span>{patient?.name}</span>
        <span className={classes.ModalDate}>
          {PATIENT_CREATED_AT_PREFIX} {formatDate(patient?.createdAt)}
        </span>
      </div>
    }
    titleFontSize="16px"
    width={800}
    footer={null}
  >
    <DetailsCard title={getScreeningsCountText(patient?.screeningsCount ?? "-")}>
      <Table
        columns={PATIENT_SCREENINGS_COLUMNS}
        dataSource={patient?.screenings || []}
        locale={{ emptyText: EMPTY_SCREENINGS_LABEL }}
        pagination={false}
        rowKey="number"
        tableLayout="fixed"
      />
    </DetailsCard>
  </ModalBase>
);

export default PatientDetailsModal;
